import { useQuery } from "@tanstack/react-query";
import { Panel } from "components/panels";
import React from "react";
import { ContactAliasesTable } from "./ContactAliasesTable";

interface Props {
  contactId: number
  canModify: boolean
}

export const ContactAliasesPanel = (props: Props) => {
  const query = useQuery({
    queryKey: ["contactAliases", props.contactId],
    queryFn: async () => window.CoreApi.ContactAlias.ListByContact(props.contactId).then(r => r.data),
  });

  const data = query.data?.data ?? [];

  return <Panel
    title="Aliases"
    panelClassName="s1_related-feature-panel"
    isLoading={query.isLoading}
    hasData={data.length > 0}
  >
    <ContactAliasesTable
      aliases={data}
      canModify={props.canModify}
      onDeleted={query.refetch}
    />
  </Panel>
}
